import { Box, Text as TextG } from "grommet";
import { Fragment } from "react";
import Text from "@components/text";
import formatDateUtc from "@helpers/formatDate";
import { Topic } from "./topics";

export default function Info({ article, size = "small", showAuthor, ...rest }) {
  const { category, created } = article;

  return (
    <Box {...rest}>
      <Box direction="row" align="center">
        {showAuthor && (
          <Fragment>
            <TextG as="em" truncate size={size}>
              By the Coinscope Team
            </TextG>
            <Text
              size={size}
              margin={{ horizontal: "xsmall" }}
              color="status-disabled"
            >
              ·
            </Text>
          </Fragment>
        )}
        <Text weight="normal" size={size} color="status-disabled">
          {formatDateUtc(created)}
        </Text>
        <Text
          size={size}
          margin={{ horizontal: "xsmall" }}
          color="status-disabled"
        >
          ·
        </Text>
        <Topic value={category} size="small" />
      </Box>
    </Box>
  );
}
